import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'request-name-dialog',
    templateUrl: './request-name.component.html',
    styleUrls: ['./request-name.component.scss'],
    standalone: false
})
  export class SendSmartSmsToResidentsRequestNameDialog {

    requestName:string = '';
    constructor(
      public dialogRef: MatDialogRef<SendSmartSmsToResidentsRequestNameDialog>,

    ) {}
    
    okButtonActive(){
        return this.requestName!=null && this.requestName!=undefined && this.requestName.trim()!="";
    }

    onClose(): void {
      this.dialogRef.close();
    }
  }